import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Id, User, NotificationView } from "../types";

export interface UserState {
  user?: User;
  friends?: Id[];
  authStateLoaded: boolean;
  notifications?: NotificationView[];
}

const initialState: UserState = {
  user: undefined,
  friends: undefined,
  authStateLoaded: false,
  notifications: undefined,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loadUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.authStateLoaded = true;
    },
    cleanUser: (state) => {
      state.user = undefined;
      state.friends = undefined;
      state.authStateLoaded = true;
      state.notifications = undefined;
    },
    loadFriends: (state: UserState, action: PayloadAction<Id[]>) => {
      state.friends = action.payload;
    },
    cleanFriends: (state: UserState) => {
      state.friends = undefined;
    },
    loadNotifications: (
      state: UserState,
      action: PayloadAction<NotificationView[]>,
    ) => {
      state.notifications = action.payload;
    },
    cleanNotifications: (state: UserState) => {
      state.notifications = undefined;
    },
  },
});

export const {
  loadUser,
  cleanUser,
  loadFriends,
  cleanFriends,
  loadNotifications,
  cleanNotifications,
} = userSlice.actions;

export default userSlice.reducer;
